// extracted by mini-css-extract-plugin
export default {"footer":"banner2_page_footer__a3ZDW"};